/**
 * Slice 19c — shared visual primitives for the archetype/topic tag kind.
 * Kept in its own file so the post-tags panel, templates panel, and AI helper
 * can reuse the radio + chip without duplicating Tailwind class strings.
 */

export type TagKind = "archetype" | "topic";

export function AdsTagKindRadio(props: {
  value: TagKind;
  onChange: (v: TagKind) => void;
  idPrefix: string;
}) {
  const { value, onChange, idPrefix } = props;
  return (
    <fieldset className="flex items-center gap-3 text-[11px] text-gray-700 dark:text-gray-300">
      <legend className="sr-only">Tag kind</legend>
      <label className="flex items-center gap-1" htmlFor={`${idPrefix}-topic`}>
        <input
          id={`${idPrefix}-topic`}
          type="radio"
          name={`${idPrefix}-kind`}
          value="topic"
          checked={value === "topic"}
          onChange={() => onChange("topic")}
        />
        Topic
      </label>
      <label className="flex items-center gap-1" htmlFor={`${idPrefix}-archetype`}>
        <input
          id={`${idPrefix}-archetype`}
          type="radio"
          name={`${idPrefix}-kind`}
          value="archetype"
          checked={value === "archetype"}
          onChange={() => onChange("archetype")}
        />
        Archetype
      </label>
    </fieldset>
  );
}

export function AdsTagKindChip(props: { kind: TagKind | undefined }) {
  const kind: TagKind = props.kind === "archetype" ? "archetype" : "topic";
  const isArchetype = kind === "archetype";
  return (
    <span
      className={
        "ml-1 inline-flex items-center rounded px-1 py-px text-[9px] font-medium uppercase tracking-wide " +
        (isArchetype
          ? "bg-blue-100 text-blue-800 dark:bg-blue-900/60 dark:text-blue-200"
          : "bg-green-100 text-green-800 dark:bg-green-900/60 dark:text-green-200")
      }
    >
      {kind}
    </span>
  );
}
